<template>
	<div>
		<v-row>
			<v-col cols="12" lg="12" md="12">
				<s-crud
					title="Analisis"
					add
					edit
					remove
					search-input
					:config="config"
					@rowSelected="rowSelected($event)"
					@save="save($event)"
					@activePrd="fetchPendingRequests()"
					@remove="fetchPendingRequests()"
					@returnObject="fetchPendingRequests()"
					:filter="filter"
					ref="crudAnalysis"
				>
					<template v-slot:options>
						<!-- Cuando HAY solicitudes pendientes (> 0): Botón de alerta destacado con badge -->
						<v-btn
							v-if="pendingRequestsCount > 0"
							small
							color="amber darken-3"
							class="text-capitalize rounded-lg font-weight-bold ml-2 white--text elevation-2"
							@click="openPendingRequestsModal"
						>
							<v-badge
								:content="pendingRequestsCount"
								color="red darken-1"
								overlap
							>
								<v-icon left small color="white">mdi-bell-ring-outline</v-icon>
							</v-badge>
							Solicitudes de Calidad ({{ pendingRequestsCount }})
						</v-btn>

						<!-- Cuando NO HAY solicitudes pendientes (0): Integrado discreto al toolbar -->
						<v-btn
							v-else
							text
							small
							black
							class="text-capitalize font-weight-bold ml-2"
							@click="openPendingRequestsModal"
						>
							<v-icon left style="font-size: 16px;">mdi-bell-outline</v-icon>
							Solicitudes de Calidad (0)
						</v-btn>
					</template>

					<template v-slot:filter>
						<v-container class="pa-2 my-1">
							<v-row dense align="center">
								<v-col cols="12" sm="6" md="2">
									<s-date
										clearable
										v-model="filter.BeginDate"
										label="Fec. Emisión Inicio"
									></s-date>
								</v-col>
								<v-col cols="12" sm="6" md="2">
									<s-date
										clearable
										v-model="filter.EndDate"
										label="Fec. Emisión Fin"
									></s-date>
								</v-col>
								<v-col cols="12" sm="6" md="3">
									<s-select-campaign-area
										clearable
										no-default
										typeArea="1"
										v-model="filter.CmaID"
										label="Campaña"
									></s-select-campaign-area>
								</v-col>
								<v-col cols="12" sm="6" md="2">
									<s-select-definition
										clearable
										:def="1173"
										v-model="filter.TypeCultive"
										label="Cultivo"
									></s-select-definition>
								</v-col>
								<v-col cols="12" sm="6" md="3">
									<s-select-lot
										clearable
										no-default
										full
										v-model="filter.FltID"
										label="Sub Lote"
									></s-select-lot>
								</v-col>
							</v-row>
						</v-container>
					</template>

					<template v-slot="props">
						<v-container class="pa-2">
							<!-- Fila 1: Datos de Lote, Fundo y Productor -->
							<v-row dense class="mb-1">
								<v-col cols="12" md="2" class="s-col-form">
									<s-search-lot-by-cod-senasa
										@searchSenasa="lot => updateLotInfo(props.item, lot)"
									/>
								</v-col>
								<v-col cols="12" md="2" class="s-col-form">
									<s-text
										readonly
										label="ID Lote"
										v-model="props.item.FltID">
									</s-text>
								</v-col>
								<v-col cols="12" md="2" class="s-col-form">
									<s-text
										readonly
										label="Lote"
										v-model="props.item.FltName">
									</s-text>
								</v-col>
								<v-col cols="12" md="3" class="s-col-form">
									<s-text
										readonly
										label="Nombre de Fundo"
										v-model="props.item.FagName">
									</s-text>
								</v-col>
								<v-col cols="12" md="3" class="s-col-form">
									<s-text
										readonly
										label="Productor"
										v-model="props.item.PrdCardName">
									</s-text>
								</v-col>
							</v-row>

							<!-- Fila 2: Campaña, Nro Documento, Tipo Análisis y Tipo Matriz -->
							<v-row dense class="mb-1">
								<v-col cols="12" md="3" class="s-col-form">
									<s-select-campaign-area
										label="Campaña"
										v-model="props.item.CmaID"
										typeArea="1"
										noDefault
										full
									/>
								</v-col>
								<v-col cols="12" md="3" class="s-col-form">
									<s-text
										label="Nro Documento"
										v-model="props.item.RmnDocumentNumber">
									</s-text>
								</v-col>
								<v-col cols="12" md="3" class="s-col-form">
									<s-select-definition
										label="Tipo de Análisis"
										:def="1549"
										v-model="props.item.TypeAnalysis">
									</s-select-definition>
								</v-col>
								<v-col cols="12" md="3" class="s-col-form">
									<s-select-definition
										label="Tipo de Matriz"
										:def="1738"
										v-model="props.item.TypeMatrix">
									</s-select-definition>
								</v-col>
							</v-row>

							<!-- Fila 3: Fechas de Análisis y Vencimiento -->
							<v-row dense class="mb-2">
								<v-col cols="12" md="2" class="s-col-form">
									<s-date 
										noDefault
										clearable
										label="Fecha Envío Muestra" 
										v-model="props.item.SampleSubmissionDate">
									</s-date>
								</v-col>
								<v-col cols="12" md="2" class="s-col-form">
									<s-date 
										noDefault
										clearable
										label="Fecha Ingreso Lab." 
										v-model="props.item.LaboratoryEntryDate">
									</s-date>
								</v-col>
								<v-col cols="12" md="2" class="s-col-form">
									<s-date 
										noDefault
										clearable
										label="Fecha Propuesta Res." 
										v-model="props.item.ProposedResultsDate">
									</s-date>
								</v-col>
								<v-col cols="12" md="3" class="s-col-form">
									<s-date 
										noDefault
										clearable
										label="Fecha Emisión Resultados" 
										v-model="props.item.ResultsIssueDate"
										@change="onResultsIssueDateChange(props.item)">
									</s-date>
								</v-col>
								<v-col cols="12" md="3" class="s-col-form">
									<s-date 
										noDefault
										clearable
										label="Fecha Vencimiento" 
										v-model="props.item.ExpirationDate">
									</s-date>
								</v-col>
							</v-row>

							<!-- Sección de Documentos Adjuntos (Dropzone + Grilla de archivos) -->
							<v-row class="mt-2">
								<v-col cols="12">
									<div class="d-flex align-center mb-2">
										<v-icon color="blue darken-2" class="mr-2">mdi-paperclip</v-icon>
										<span class="text-subtitle-1 font-weight-bold grey--text text--darken-3">
											Documentos y Anexos Adjuntos
										</span>
									</div>

									<!-- Zona de Arrastre (Dropzone) -->
									<div
										class="dropzone-container pa-5 text-center rounded-lg mb-4"
										:class="{ 'dropzone-active': dragover }"
										@dragover.prevent="dragover = true"
										@dragleave.prevent="dragover = false"
										@drop.prevent="onDrop($event)"
										@click="triggerFilePicker"
									>
										<div class="d-flex flex-column align-center justify-center">
											<v-avatar
												color="blue lighten-5"
												size="60"
												class="mb-3 dropzone-icon-wrapper"
											>
												<v-icon size="32" color="blue darken-2">
													{{ dragover ? "mdi-cloud-download" : "mdi-cloud-upload-outline" }}
												</v-icon>
											</v-avatar>

											<div class="text-subtitle-1 font-weight-bold grey--text text--darken-3 mb-1">
												{{ dragover ? "¡Suelta los archivos aquí!" : "Arrastra y suelta tus archivos aquí" }}
											</div>

											<div class="text-caption grey--text text--darken-1 mb-3">
												o haz clic en cualquier parte de este recuadro para seleccionar desde tu equipo
											</div>

											<v-btn
												color="blue darken-2"
												outlined
												small
												class="text-capitalize px-4 rounded-pill font-weight-medium"
												@click.stop="triggerFilePicker"
											>
												<v-icon left small>mdi-folder-open-outline</v-icon>
												Buscar Archivos
											</v-btn>
										</div>
									</div>

									<!-- Inputs de archivo ocultos -->
									<input
										type="file"
										ref="fileInput"
										multiple
										style="display: none"
										@change="handleNativeFileInput"
									/>
									<input
										type="file"
										ref="replaceFileInput"
										style="display: none"
										@change="handleReplaceFileInput"
									/>

									<!-- Tabla de Archivos Adjuntos dentro del formulario -->
									<div class="attach-table-wrapper">
										<v-data-table
											:headers="attachHeaders"
											:items="attachList"
											dense
											hide-default-footer
											:items-per-page="-1"
											no-data-text="No se han agregado archivos aún"
											class="elevation-0"
										>
											<template v-slot:item.fileName="{ item }">
												<a
													href="#"
													@click.prevent="abrirVisorDocumento(item)"
													style="text-decoration: underline; color: #1976d2; max-width: 220px;"
													v-if="item.fileName && item.fileName.toLowerCase().endsWith('.pdf')"
													class="text-caption text-truncate d-inline-block"
												>
													<v-icon small color="red">mdi-file-pdf-box</v-icon>
													{{ item.fileName }}
												</a>
												<span
													v-else-if="item.fileName"
													class="text-caption text-truncate d-inline-block"
													style="max-width: 220px"
												>
													<v-icon small color="grey">mdi-file-document-outline</v-icon>
													{{ item.fileName }}
												</span>
											</template>

											<template v-slot:item.typeStatusApprovals="{ item }">
												<v-chip
													x-small
													v-if="item.status === 'pendiente' && !item.isReplaced && (!item.RmaID || item.RmaID === 0)"
													color="orange"
													dark
												>
													Por Guardar
												</v-chip>
												<v-chip
													x-small
													v-else-if="item.isReplaced"
													color="purple darken-1"
													dark
												>
													<v-icon x-small left>mdi-file-check-outline</v-icon>
													Subsanado (Por Guardar)
												</v-chip>
												<v-chip
													x-small
													v-else
													:color="
														item.typeStatusApprovals == 2
															? 'success'
															: item.typeStatusApprovals == 3
															? 'error'
															: item.typeStatusApprovals == 4
															? 'purple darken-1'
															: 'warning'
													"
													dark
												>
													<v-icon x-small left v-if="item.typeStatusApprovals == 3">
														mdi-alert-circle
													</v-icon>
													<v-icon x-small left v-else-if="item.typeStatusApprovals == 2">
														mdi-check-circle
													</v-icon>
													<v-icon x-small left v-else-if="item.typeStatusApprovals == 4">
														mdi-file-check-outline
													</v-icon>
													{{
														item.typeStatusApprovals == 2
															? "Aprobado"
															: item.typeStatusApprovals == 3
															? "Observado"
															: item.typeStatusApprovals == 4
															? "Subsanado"
															: "Pendiente"
													}}
												</v-chip>
											</template>

											<template v-slot:item.Observation="{ item }">
												<span
													v-if="item.Observation"
													:class="
														item.typeStatusApprovals == 3
															? 'red--text font-weight-medium text-caption'
															: item.typeStatusApprovals == 4
															? 'purple--text text--darken-2 font-weight-medium text-caption'
															: 'text-caption text-truncate d-inline-block'
													"
													style="max-width: 200px"
													:title="item.Observation"
												>
													{{ item.Observation }}
												</span>
												<span v-else class="text-caption grey--text">-</span>
											</template>

											<template v-slot:item.download="{ item }">
												<v-btn
													icon
													x-small
													color="blue darken-2"
													:disabled="item.status !== 'guardado'"
													@click="openFile(item.fileName)"
												>
													<v-icon x-small>mdi-download</v-icon>
												</v-btn>
											</template>

											<template v-slot:item.actions="{ item }">
												<div class="d-flex align-center justify-center" v-if="props.item.TypeStatusApprovals != 2 && props.item.typeStatusApprovals != 2">
													<v-btn
														v-if="(item.typeStatusApprovals == 3 || item.typeStatusApprovals == 4 || item.isReplaced) && item.typeStatusApprovals != 2"
														icon
														x-small
														color="amber darken-3"
														@click.stop="triggerReplaceFile(item)"
														:title="item.isReplaced || item.typeStatusApprovals == 4 ? 'Cambiar archivo subsanado' : 'Subsanar / Reemplazar archivo observado'"
														class="mr-1"
													>
														<v-icon x-small>mdi-file-replace-outline</v-icon>
													</v-btn>
													<v-btn
														v-if="item.isReplaced"
														icon
														x-small
														color="blue-grey"
														@click.stop="cancelReplaceFile(item)"
														title="Deshacer subsanación"
														class="mr-1"
													>
														<v-icon x-small>mdi-undo</v-icon>
													</v-btn>
													<v-btn
														v-if="item.typeStatusApprovals != 2"
														icon
														x-small
														color="red lighten-1"
														@click.stop="deleteAttachment(item)"
														title="Eliminar archivo"
													>
														<v-icon x-small>mdi-delete</v-icon>
													</v-btn>
												</div>
											</template>
										</v-data-table>
									</div>
								</v-col>
							</v-row>
						</v-container>
					</template>

					<!-- Columna de Adjuntos en el CRUD General -->
					<template v-slot:CountAttachment="{ row }">
						<v-btn
							icon
							color="blue darken-2"
							@click="openViewAttachments(row)"
							title="Ver Archivos Adjuntos"
						>
							<v-badge
								:content="row.CountAttachment"
								color="red"
								overlap
								v-if="row.CountAttachment > 0"
							>
								<v-icon>mdi-paperclip</v-icon>
							</v-badge>
							<v-icon v-else>mdi-paperclip</v-icon>
						</v-btn>
					</template>

					<!-- Columna de Documentos Observados -->
					<template v-slot:CountRejectedAttachment="{ row }">
						<v-chip
							x-small
							color="red lighten-5"
							text-color="red darken-3"
							class="font-weight-bold"
							v-if="row.CountRejectedAttachment > 0"
							:title="'Tiene ' + row.CountRejectedAttachment + ' documento(s) observado(s)'"
						>
							<v-icon x-small left color="red darken-3">
								mdi-alert-circle
							</v-icon>
							{{ row.CountRejectedAttachment }}
						</v-chip>
						<span v-else class="text-caption grey--text text--lighten-1">-</span>
					</template>

					<!-- Columna de Documentos Subsanados -->
					<template v-slot:CountSubsanadoAttachment="{ row }">
						<v-chip
							x-small
							color="purple lighten-5"
							text-color="purple darken-3"
							class="font-weight-bold"
							v-if="row.CountSubsanadoAttachment > 0"
							:title="'Tiene ' + row.CountSubsanadoAttachment + ' documento(s) subsanado(s)'"
						>
							<v-icon x-small left color="purple darken-3">
								mdi-file-check-outline
							</v-icon>
							{{ row.CountSubsanadoAttachment }}
						</v-chip>
						<span v-else class="text-caption grey--text text--lighten-1">-</span>
					</template>

					<!-- Columna de Estado del Análisis (Confirmación de Resultados) -->
					<template v-slot:TypeStatusApprovalsName="{ row }">
						<v-chip
							x-small
							:color="getHeaderStatusBgColor(row)"
							:text-color="getHeaderStatusTextColor(row)"
							class="font-weight-bold"
						>
							<v-icon x-small left :color="getHeaderStatusIconColor(row)" v-if="getHeaderStatusIcon(row)">
								{{ getHeaderStatusIcon(row) }}
							</v-icon>
							{{ row.TypeStatusApprovalsName || getHeaderStatusText(row) }}
						</v-chip>
					</template>

					<!-- Columna de Fecha de Aprobación -->
					<template v-slot:DateApproval="{ row }">
						<span class="text-caption">
							{{
								row.DateApproval
									? $moment(row.DateApproval).format("DD/MM/YYYY HH:mm")
									: ""
							}}
						</span>
					</template>

					<!-- Columna de Fecha de Vencimiento -->
					<template v-slot:ExpirationDate="{ row }">
						<span class="text-caption" v-if="row.ExpirationDate">
							{{ $moment(row.ExpirationDate).format("DD/MM/YYYY") }}
						</span>
						<span class="text-caption grey--text" v-else>-</span>
					</template>

					<!-- Columna de Estado del Vencimiento (Semáforo de Calidad) -->
					<template v-slot:ExpirationStatus="{ row }">
						<v-chip
							x-small
							:color="getExpirationStatusBgColor(row)"
							:text-color="getExpirationStatusTextColor(row)"
							class="font-weight-bold"
							v-if="row.ExpirationDate"
							:title="getExpirationStatusTitle(row)"
						>
							<v-icon x-small left :color="getExpirationStatusIconColor(row)">{{ getExpirationStatusIcon(row) }}</v-icon>
							{{ getExpirationStatusText(row) }}
						</v-chip>
						<span class="text-caption grey--text text--lighten-1" v-else>-</span>
					</template>
				</s-crud>
			</v-col>
		</v-row>

		<!-- Modal de Archivos Adjuntos (General) -->
		<v-dialog v-model="dialogAttachmentsModal" max-width="800px">
			<v-card class="rounded-lg">
				<v-card-title class="headline grey lighten-2 py-3 px-4">
					<span style="color: #333; font-weight: 600; font-size: 1.1rem">
						Archivos Adjuntos del Análisis
					</span>
					<v-spacer></v-spacer>
					<v-btn icon @click="dialogAttachmentsModal = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text class="pa-4">
					<div class="attach-table-wrapper">
						<v-data-table
							:headers="modalAttachHeaders"
							:items="modalAttachList"
							dense
							hide-default-footer
							:items-per-page="-1"
							no-data-text="No se han encontrado archivos"
							class="elevation-0"
						>
							<template v-slot:item.fileName="{ item }">
								<a
									href="#"
									@click.prevent="abrirVisorDocumento(item)"
									style="text-decoration: underline; color: #1976d2; max-width: 200px;"
									v-if="item.fileName && item.fileName.toLowerCase().endsWith('.pdf')"
									class="text-caption text-truncate d-inline-block"
								>
									<v-icon small color="red">mdi-file-pdf-box</v-icon>
									{{ item.fileName }}
								</a>
								<span
									v-else-if="item.fileName"
									class="text-caption text-truncate d-inline-block"
									style="max-width: 200px"
								>
									<v-icon small color="grey">mdi-file-document-outline</v-icon>
									{{ item.fileName }}
								</span>
							</template>

							<template v-slot:item.typeStatusApprovals="{ item }">
								<v-chip
									x-small
									:color="
										item.typeStatusApprovals == 2
											? 'success'
											: item.typeStatusApprovals == 3
											? 'error'
											: item.typeStatusApprovals == 4
											? 'purple darken-1'
											: 'warning'
									"
									dark
								>
									<v-icon x-small left v-if="item.typeStatusApprovals == 3">mdi-alert-circle</v-icon>
									<v-icon x-small left v-else-if="item.typeStatusApprovals == 2">mdi-check-circle</v-icon>
									<v-icon x-small left v-else-if="item.typeStatusApprovals == 4">mdi-file-check-outline</v-icon>
									{{
										item.typeStatusApprovals == 2
											? "Aprobado"
											: item.typeStatusApprovals == 3
											? "Observado"
											: item.typeStatusApprovals == 4
											? "Subsanado"
											: "Pendiente"
									}}
								</v-chip>
							</template>

							<template v-slot:item.Observation="{ item }">
								<span
									v-if="item.Observation"
									:class="
										item.typeStatusApprovals == 3
											? 'red--text font-weight-medium text-caption'
											: item.typeStatusApprovals == 4
											? 'purple--text text--darken-2 font-weight-medium text-caption'
											: 'text-caption text-truncate d-inline-block'
									"
									style="max-width: 220px"
									:title="item.Observation"
								>
									{{ item.Observation }}
								</span>
								<span v-else class="text-caption grey--text">-</span>
							</template>

							<template v-slot:item.download="{ item }">
								<v-btn
									icon
									x-small
									color="blue darken-2"
									@click="openFile(item.fileName)"
								>
									<v-icon x-small>mdi-download</v-icon>
								</v-btn>
							</template>
						</v-data-table>
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>

		<!-- Modal Solicitudes Pedidas por Calidad -->
		<v-dialog v-model="dialogPendingRequests" max-width="850px">
			<v-card class="rounded-xl">
				<v-card-title class="py-3 px-4 d-flex align-center border-light-bottom bg-white">
					<v-avatar color="amber lighten-5" size="40" class="mr-3">
						<v-icon color="amber darken-4" small>mdi-bell-alert-outline</v-icon>
					</v-avatar>
					<div>
						<h3 class="text-subtitle-1 font-weight-black grey--text text--darken-4 mb-0">
							Solicitudes de Re-Muestreo Enviadas por Calidad
						</h3>
						<span class="caption grey--text text--darken-2">
							Atención e ingreso de nuevo análisis por vencimiento o dictamen preventivo
						</span>
					</div>
					<v-spacer></v-spacer>
					<v-btn icon small @click="dialogPendingRequests = false">
						<v-icon color="grey darken-2">mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider></v-divider>

				<v-card-text class="pa-4">
					<v-data-table
						:headers="pendingRequestsHeaders"
						:items="pendingRequestsList"
						:loading="loadingPendingRequests"
						loading-text="Cargando solicitudes de Calidad..."
						no-data-text="No hay solicitudes pendientes de Calidad"
						dense
						class="elevation-0 border-rounded"
					>
						<!-- Columna Prioridad -->
						<template v-slot:item.RequestPriority="{ item }">
							<v-chip
								x-small
								:color="item.RequestPriority === 'URGENTE' ? 'red lighten-5' : item.RequestPriority === 'ALTA' ? 'amber lighten-5' : 'blue lighten-5'"
								:text-color="item.RequestPriority === 'URGENTE' ? 'red darken-3' : item.RequestPriority === 'ALTA' ? 'amber darken-4' : 'blue darken-3'"
								class="font-weight-bold"
							>
								<v-icon x-small left :color="item.RequestPriority === 'URGENTE' ? 'red darken-3' : item.RequestPriority === 'ALTA' ? 'amber darken-4' : 'blue darken-3'">
									{{ item.RequestPriority === 'URGENTE' ? 'mdi-alert-circle' : item.RequestPriority === 'ALTA' ? 'mdi-clock-alert-outline' : 'mdi-information-outline' }}
								</v-icon>
								{{ item.RequestPriority || 'NORMAL' }}
							</v-chip>
						</template>

						<!-- Columna Lote -->
						<template v-slot:item.FltName="{ item }">
							<div class="d-flex flex-column py-1">
								<span class="font-weight-bold text-body-2 grey--text text--darken-4">ID Lote: {{ item.FltID }}</span>
							</div>
						</template>

						<!-- Columna Acción -->
						<template v-slot:item.actions="{ item }">
							<v-btn
								small
								color="primary"
								class="text-capitalize font-weight-bold rounded-lg elevation-0"
								@click="attendRequestFromModal(item)"
							>
								<v-icon left small>mdi-flask-empty-plus</v-icon>
								Atender y Crear Análisis
							</v-btn>
						</template>
					</v-data-table>
				</v-card-text>
			</v-card>
		</v-dialog>

		<!-- Modal Visor PDF -->
		<v-dialog v-model="visorDocumentoVisible" max-width="90%" persistent>
			<v-card class="rounded-lg">
				<v-card-title class="headline grey lighten-2 py-2 px-4">
					<span style="color: #333; font-weight: 600; font-size: 1.1rem" class="text-truncate">
						Visor de Documento: {{ documentoActualNombre }}
					</span>
					<v-spacer></v-spacer>
					<v-btn icon @click="cerrarVisorPdf">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text style="height: 80vh; padding: 0">
					<iframe
						v-if="pdfLocalPath"
						:src="pdfLocalPath"
						width="100%"
						height="100%"
						style="border: none; background-color: #f8fafc"
					></iframe>
					<v-container v-if="descargandoDocumento" fill-height>
						<v-row align="center" justify="center">
							<v-col class="text-center">
								<v-progress-circular
									indeterminate
									color="primary"
									size="64"
								></v-progress-circular>
								<p class="mt-4 text--secondary">Cargando documento...</p>
							</v-col>
						</v-row>
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
	import _sService from "../../../../services/Technicalassistance/TasRawMaterialAnalysisService";
	import SSearchLotByCodSenasa from "@/components/HarvestSchedule/sSearchLotByCodSenasa.vue";
	import SSelectCampaignArea from "@/components/Utils/SSelectCampaignArea.vue";
	import SSelectLot from "@/components/HarvestSchedule/SSelectLot.vue";
	import _sGeneral from "@/services/HelperService.js";

	export default {
		components: {
			SSearchLotByCodSenasa,
			SSelectCampaignArea,
			SSelectLot,
		},
		props: {},
		data: () => ({
			item: {},
			filter: {
				BeginDate: null,
				EndDate: null,
				CmaID: null,
				FltID: null,
				TypeCultive: null,
			},
			selectedItem: {},
			currentFormRmnID: null,

			// Solicitudes de Calidad
			dialogPendingRequests: false,
			loadingPendingRequests: false,
			pendingRequestsList: [],
			pendingRequestsCount: 0,
			activeRequestRmrID: 0,
			pendingRequestsHeaders: [
				{ text: "Prioridad", value: "RequestPriority", width: "110", align: "center", sortable: true },
				{ text: "Lote / Sub Lote", value: "FltName", width: "140", sortable: true },
				{ text: "Fundo", value: "FagName", width: "130", sortable: true },
				{ text: "Productor", value: "PrdCardName", width: "150", sortable: true },
				{ text: "Tipo Análisis", value: "TypeAnalysisName", width: "130", sortable: true },
				{ text: "Instrucción de Calidad", value: "RequestObservation", width: "200", sortable: false },
				{ text: "Acción", value: "actions", width: "170", align: "center", sortable: false },
			],

			// Archivos Adjuntos
			attachList: [],
			deletedAttachList: [],
			dragover: false,
			attachForm: {
				files: [],
			},
			attachHeaders: [
				{ text: "Archivo", value: "fileName", sortable: false },
				{
					text: "Estado Adjunto",
					value: "typeStatusApprovals",
					sortable: false,
					width: 130,
					align: "center",
				},
				{ text: "Observación", value: "Observation", sortable: false, width: 220 },
				{
					text: "Descargar",
					value: "download",
					sortable: false,
					width: 70,
					align: "center",
				},
				{
					text: "Acciones",
					value: "actions",
					sortable: false,
					width: 100,
					align: "center",
				},
			],
			replaceTargetItem: null,

			// Modal Adjuntos (Consulta General)
			dialogAttachmentsModal: false,
			modalAttachList: [],
			modalAttachHeaders: [
				{ text: "Archivo", value: "fileName", sortable: false },
				{
					text: "Estado Adjunto",
					value: "typeStatusApprovals",
					sortable: false,
					width: 120,
					align: "center",
				},
				{ text: "Observación", value: "Observation", sortable: false, width: 240 },
				{
					text: "Descargar",
					value: "download",
					sortable: false,
					width: 70,
					align: "center",
				},
			],

			// Visor PDF
			visorDocumentoVisible: false,
			descargandoDocumento: false,
			pdfLocalPath: null,
			documentoActualNombre: "",

			config: {
				model: {
					RmnID: "ID",
					SampleSubmissionDate: "date",
					LaboratoryEntryDate: "date",
					ProposedResultsDate: "date",
					ResultsIssueDate: "date",
					ExpirationDate: "date",
					SecStatus: "status",
					TasRawMaterialAnalysisAttachment: [],
				},
				service: _sService,
				headers: [
					{ text: "ID", value: "RmnID", width: "55", align: "center", sortable: true },
					{
						text: "Adjuntos",
						value: "CountAttachment",
						width: "75",
						sortable: true,
						align: "center",
					},
					{
						text: "Observados",
						value: "CountRejectedAttachment",
						width: "95",
						sortable: true,
						align: "center",
					},
					{
						text: "Subsanados",
						value: "CountSubsanadoAttachment",
						width: "95",
						sortable: true,
						align: "center",
					},
					{
						text: "Dictamen LMR",
						value: "TypeStatusApprovalsName",
						width: "140",
						sortable: true,
						align: "center",
					},
					{
						text: "Vencimiento",
						value: "ExpirationStatus",
						width: "135",
						sortable: true,
						align: "center",
					},
					{ text: "Campaña", value: "CmaName", width: "120", sortable: true },
					{ text: "ID Lote", value: "FltID", width: "75", align: "center", sortable: true },
					{ text: "Lote", value: "FltName", width: "85", sortable: true },
					{ text: "Fundo", value: "FagName", width: "140", sortable: true },
					{ text: "Productor", value: "PrdCardName", width: "170", sortable: true },
					{ text: "Nro Documento", value: "RmnDocumentNumber", width: "115", sortable: true },
					{ text: "Tipo de Análisis", value: "TypeAnalysisName", width: "120", sortable: true },
					{ text: "Tipo de Matriz", value: "TypeMatrixName", width: "110", sortable: true },
					{ text: "Fec. Envío Muestra", value: "SampleSubmissionDate", width: "125", align: "center", sortable: true },
					{ text: "Fec. Ingreso Lab.", value: "LaboratoryEntryDate", width: "120", align: "center", sortable: true },
					{ text: "Fec. Propuesta Res.", value: "ProposedResultsDate", width: "130", align: "center", sortable: true },
					{ text: "Fec. Emisión Res.", value: "ResultsIssueDate", width: "125", align: "center", sortable: true },
					{ text: "Fec. Vencimiento", value: "ExpirationDate", width: "125", align: "center", sortable: true },
					
					{
						text: "Fecha Confirmación",
						value: "DateApproval",
						width: "130",
						align: "center",
						sortable: true,
					},
				],
			},
		}),
		mounted() {
			this.fetchPendingRequests();
		},
		beforeDestroy() {
			if (this.pdfLocalPath) {
				URL.revokeObjectURL(this.pdfLocalPath);
			}
		},
		methods: {
			async fetchPendingRequests() {
				this.loadingPendingRequests = true;
				try {
					const dtr = {
						draw: 1,
						start: 0,
						length: 100,
						orderColumn: "RmrID",
						orderDir: "DESC",
						searchText: "",
					};
					const userId = this.$fun ? this.$fun.getUserID() : 1;
					const res = await _sService.requestPagination(dtr, userId, 0); // 0 = Pendientes (isAttended=0)
					if (res && res.status === 200) {
						let list = [];
						if (res.data && Array.isArray(res.data.data)) {
							list = res.data.data;
							this.pendingRequestsCount = res.data.recordsTotal || list.length;
						} else if (Array.isArray(res.data)) {
							list = res.data;
							this.pendingRequestsCount = list.length;
						}
						this.pendingRequestsList = list;
					}
				} catch (e) {
					console.error("Error fetching pending requests", e);
				} finally {
					this.loadingPendingRequests = false;
				}
			},
			openPendingRequestsModal() {
				this.dialogPendingRequests = true;
				this.fetchPendingRequests();
			},
			attendRequestFromModal(item) {
				if (!item) return;
				this.activeRequestRmrID = item.RmrID;
				this.dialogPendingRequests = false;
				this.newAnalysisForLot(item);
			},
			clearForm() {
				this.attachList = [];
				this.deletedAttachList = [];
				this.attachForm.files = [];
				this.replaceTargetItem = null;
				if (this.$refs.fileInput) {
					this.$refs.fileInput.value = "";
				}
				if (this.$refs.replaceFileInput) {
					this.$refs.replaceFileInput.value = "";
				}
			},
			async rowSelected(rows) {
				this.clearForm();

				if (rows && rows.length > 0) {
					const selected = rows[0];
					this.selectedItem = selected;
					this.$emit("rowSelected", rows);

					const fetchRmnID = selected.RmnID ? Number(selected.RmnID) : 0;
					this.currentFormRmnID = fetchRmnID;

					if (fetchRmnID > 0) {
						try {
							const res = await _sService.AttachmentList(
								fetchRmnID,
								this.$fun.getUserID()
							);
							if (this.currentFormRmnID !== fetchRmnID) {
								return;
							}
							if (res.status === 200) {
								let list = Array.isArray(res.data) ? res.data : res.data.data || [];
								this.attachList = list.map((item) => ({
									RmaID: item.RmaID || item.rmaID || 0,
									RmnID: item.RmnID || item.rmnID || 0,
									fileName: item.FilePath || item.filePath,
									typeStatusApprovals: item.TypeStatusApprovals || item.typeStatusApprovals || 1,
									typeStatusApprovalsName:
										item.TypeStatusApprovalsName ||
										item.typeStatusApprovalsName ||
										(item.TypeStatusApprovals == 4
											? "NO CONFORME"
											: item.TypeStatusApprovals == 3
											? "RESTRINGIDO"
											: item.TypeStatusApprovals == 2
											? "APROBADO"
											: "PENDIENTE"),
									Observation: item.Observation || item.observation || "",
									DateApproval: item.DateApproval || item.dateApproval || null,
									UsrIDApprovalName: item.UsrApprovalName || item.usrApprovalName || "",
									fileSize: "-",
									status: "guardado",
								}));
							}
						} catch (e) {
							console.error("Error fetching attachments", e);
						}
					}
				} else {
					this.selectedItem = {};
					this.currentFormRmnID = null;
					this.$emit("rowSelected", []);
				}
			},
			async openViewAttachments(row) {
				this.modalAttachList = [];
				this.dialogAttachmentsModal = true;
				try {
					const res = await _sService.AttachmentList(
						row.RmnID,
						this.$fun.getUserID()
					);
					if (res.status === 200) {
						let list = Array.isArray(res.data) ? res.data : res.data.data || [];
						this.modalAttachList = list.map((item) => ({
							RmaID: item.RmaID || item.rmaID || 0,
							RmnID: item.RmnID || item.rmnID || 0,
							fileName: item.FilePath || item.filePath,
							typeStatusApprovals: item.TypeStatusApprovals || item.typeStatusApprovals || 1,
							typeStatusApprovalsName:
								item.TypeStatusApprovalsName ||
								item.typeStatusApprovalsName ||
								(item.TypeStatusApprovals == 4
									? "NO CONFORME"
									: item.TypeStatusApprovals == 3
									? "RESTRINGIDO"
									: item.TypeStatusApprovals == 2
									? "APROBADO"
									: "PENDIENTE"),
							DateApproval: item.DateApproval || item.dateApproval || null,
							UsrIDApprovalName: item.UsrApprovalName || item.usrApprovalName || "",
							Observation: item.Observation || item.observation || "",
							fileSize: "-",
							status: "guardado",
						}));
					}
				} catch (e) {
					console.error("Error fetching attachments", e);
				}
			},
			triggerFilePicker() {
				if (this.$refs.fileInput) {
					this.$refs.fileInput.click();
				}
			},
			triggerReplaceFile(item) {
				if (
					(this.selectedItem && (this.selectedItem.TypeStatusApprovals == 2 || this.selectedItem.typeStatusApprovals == 2)) ||
					(item && item.typeStatusApprovals == 2)
				) {
					this.$fun.alert(
						"El archivo o registro se encuentra aprobado y no puede ser modificado.",
						"warning"
					);
					return;
				}
				this.replaceTargetItem = item;
				if (this.$refs.replaceFileInput) {
					this.$refs.replaceFileInput.value = "";
					this.$refs.replaceFileInput.click();
				}
			},
			handleReplaceFileInput(e) {
				const file = e.target.files && e.target.files[0];
				if (!file) return;

				const target = this.replaceTargetItem;
				if (!target) return;

				const index = this.attachList.indexOf(target);
				if (index === -1) return;

				if (!target.isReplaced) {
					target.originalData = {
						fileName: target.fileName,
						fileSize: target.fileSize,
						typeStatusApprovals: target.typeStatusApprovals,
						typeStatusApprovalsName: target.typeStatusApprovalsName,
						status: target.status,
					};
				}

				target.file = file;
				target.fileName = file.name;
				target.fileSize = (file.size / 1024).toFixed(1) + " KB";
				target.status = "pendiente";
				target.typeStatusApprovals = 4;
				target.typeStatusApprovalsName = "SUBSANADO";
				target.isReplaced = true;

				this.$set(this.attachList, index, { ...target });
				this.replaceTargetItem = null;
				e.target.value = "";

				this.$fun.alert(
					"Archivo subsanado. Estado cambiado a Subsanado. Recuerde guardar los cambios.",
					"success"
				);
			},
			cancelReplaceFile(item) {
				const index = this.attachList.indexOf(item);
				if (index === -1) return;
				const target = this.attachList[index];
				if (target && target.originalData) {
					const restored = {
						...target,
						...target.originalData,
					};
					delete restored.originalData;
					delete restored.isReplaced;
					delete restored.file;
					this.$set(this.attachList, index, restored);
					this.$fun.alert("Reemplazo cancelado.", "info");
				}
			},
			handleNativeFileInput(e) {
				const files = Array.from(e.target.files || []);
				if (files.length > 0) {
					this.attachForm.files = files;
					this.addAttachToList();
				}
				e.target.value = "";
			},
			addAttachToList() {
				if (this.selectedItem && (this.selectedItem.TypeStatusApprovals == 2 || this.selectedItem.typeStatusApprovals == 2)) {
					this.$fun.alert(
						"El registro está aprobado y no se pueden agregar archivos.",
						"warning"
					);
					return;
				}
				const { files } = this.attachForm;
				if (!files || files.length === 0) {
					this.$fun.alert("Seleccione al menos un archivo", "warning");
					return;
				}

				let duplicados = 0;
				files.forEach((file) => {
					const exists = this.attachList.some(
						(item) => item.fileName === file.name
					);
					if (exists) {
						duplicados++;
						return;
					}

					const sizeKB = (file.size / 1024).toFixed(1);
					this.attachList.push({
						RmaID: 0,
						RmnID: 0,
						fileName: file.name,
						fileSize: sizeKB + " KB",
						file,
						status: "pendiente",
						typeStatusApprovals: 1,
						typeStatusApprovalsName: "PENDIENTE",
					});
				});

				if (duplicados > 0) {
					this.$fun.alert(
						`${duplicados} archivo(s) omitidos por estar duplicados.`,
						"info"
					);
				}
				this.attachForm.files = [];
			},
			async onDrop(e) {
				this.dragover = false;
				if (this.selectedItem && (this.selectedItem.TypeStatusApprovals == 2 || this.selectedItem.typeStatusApprovals == 2)) {
					return;
				}
				const items = e.dataTransfer.items;

				if (items && items.length > 0) {
					const files = [];
					const promises = [];

					for (let i = 0; i < items.length; i++) {
						const item = items[i];
						if (item.kind === "file") {
							const entry = item.webkitGetAsEntry
								? item.webkitGetAsEntry()
								: null;
							if (entry) {
								promises.push(this.traverseFileTree(entry, files));
							} else {
								files.push(item.getAsFile());
							}
						}
					}

					await Promise.all(promises);

					if (files.length > 0) {
						this.attachForm.files = files;
						this.addAttachToList();
					}
				} else if (e.dataTransfer.files.length > 0) {
					this.attachForm.files = Array.from(e.dataTransfer.files);
					this.addAttachToList();
				}
			},
			traverseFileTree(item, filesArr) {
				return new Promise((resolve) => {
					if (item.isFile) {
						item.file((file) => {
							filesArr.push(file);
							resolve();
						});
					} else if (item.isDirectory) {
						const dirReader = item.createReader();
						dirReader.readEntries(async (entries) => {
							const promises = [];
							for (let i = 0; i < entries.length; i++) {
								promises.push(this.traverseFileTree(entries[i], filesArr));
							}
							await Promise.all(promises);
							resolve();
						});
					} else {
						resolve();
					}
				});
			},
			async deleteAttachment(item) {
				const index = typeof item === "number" ? item : this.attachList.indexOf(item);
				if (index === -1) return;
				const attach = this.attachList[index];
				if (
					(this.selectedItem && (this.selectedItem.TypeStatusApprovals == 2 || this.selectedItem.typeStatusApprovals == 2)) ||
					(attach && attach.typeStatusApprovals == 2)
				) {
					this.$fun.alert(
						"El registro o archivo está aprobado y no se puede eliminar.",
						"warning"
					);
					return;
				}
				if (attach.status === "guardado" && attach.RmaID > 0) {
					const confirm = await this.$fun.alert(
						"¿Está seguro de eliminar este archivo adjunto?",
						"question"
					);
					if (!confirm.value) return;
					this.deletedAttachList.push(attach);
				}
				this.attachList.splice(index, 1);
			},
			async save(item) {
				if (!item.FltID) {
					this.$fun.alert("Debe seleccionar un Lote", "warning");
					return;
				}
				if (!item.CmaID) {
					this.$fun.alert("Debe seleccionar una Campaña", "warning");
					return;
				}
				if (item.TypeStatusApprovals == 2 || item.typeStatusApprovals == 2) {
					this.$fun.alert(
						"El registro ya se encuentra aprobado y no puede ser modificado.",
						"warning"
					);
					return;
				}

				// Subir archivos físicos pendientes
				const pending = this.attachList.filter((x) => x.status === "pendiente");
				if (pending.length > 0) {
					const formData = new FormData();
					pending.forEach((row, index) => {
						formData.append(index.toString(), row.file);
					});

					try {
						const uploadRes = await _sGeneral.uploadfile(
							"Analysis",
							this.$fun.getUserID(),
							formData,
							3
						);
						if (uploadRes.status !== 200) {
							this.$fun.alert("Error al subir los archivos físicos", "warning");
							return;
						}
					} catch (e) {
						console.error(e);
						this.$fun.alert("Error al subir los archivos físicos", "warning");
						return;
					}
				}

				const validAttachments = this.attachList.map((a) => ({
					RmaID: a.RmaID || 0,
					RmnID: item.RmnID || 0,
					FilePath: a.fileName,
					TypeStatusApprovals: a.typeStatusApprovals || (a.isReplaced ? 4 : 1),
					Observation: a.Observation || null,
					SecStatus: 1,
					UsrCreateID: this.$fun.getUserID(),
				}));

				const deletedAttachments = this.deletedAttachList.map((a) => ({
					RmaID: a.RmaID || 0,
					RmnID: item.RmnID || 0,
					FilePath: a.fileName,
					SecStatus: 0,
					UsrCreateID: this.$fun.getUserID(),
				}));

				item.TasRawMaterialAnalysisAttachment = [
					...validAttachments,
					...deletedAttachments,
				];

				item.UsrUpdateID = this.$fun.getUserID();
				item.UsrCreateID = this.$fun.getUserID();
				item.SecStatus = 1;

				try {
					const resp = await _sService.save(item, this.$fun.getUserID());
					if (resp.status === 200) {
						if (this.activeRequestRmrID && this.activeRequestRmrID > 0) {
							try {
								const generatedId = (resp.data && (resp.data.RmnID || resp.data.rmnID)) || item.RmnID || 0;
								await _sService.requestAttend(
									this.activeRequestRmrID,
									generatedId,
									this.$fun.getUserID()
								);
							} catch (eReq) {
								console.error("Error atending request:", eReq);
							}
							this.activeRequestRmrID = 0;
							this.fetchPendingRequests();
						}
						this.$fun.alert("Se guardó correctamente", "success");
						this.clearForm();
						this.fetchPendingRequests();
						this.$refs.crudAnalysis.refresh();
					}
				} catch (err) {
					this.$fun.alert("Error al guardar: " + (err.message || err), "error");
				}
			},
			updateLotInfo(item, lot) {
				item.FltID = lot.FltID;
				item.FltName = lot.FltName;
				item.FagName = lot.FagName;
				item.PrdCardName = lot.PrdCardName;
				item.RmnLotSenasa = lot.FltCodSenasa;
			},
			openFile(nameFile) {
				if (!nameFile) return;
				_sGeneral.download(nameFile, this.$fun.getUserID()).then((r) => {
					if (r.status === 200) {
						this.$fun.download(r.data, nameFile);
					} else {
						this.$fun.alert("El archivo no se encuentra disponible", "warning");
					}
				});
			},
			async abrirVisorDocumento(item) {
				if (this.descargandoDocumento) return;
				if (item.status !== "guardado") {
					this.$fun.alert(
						"Debes guardar el registro primero para visualizar el PDF.",
						"warning"
					);
					return;
				}

				if (!item.fileName || !item.fileName.toLowerCase().endsWith(".pdf")) {
					this.$fun.alert(
						"El visor en línea solo soporta archivos PDF. Utilice el botón de descarga.",
						"info"
					);
					return;
				}

				if (this.pdfLocalPath) {
					URL.revokeObjectURL(this.pdfLocalPath);
					this.pdfLocalPath = null;
				}

				this.descargandoDocumento = true;
				this.documentoActualNombre = item.fileName;
				this.visorDocumentoVisible = true;

				try {
					const response = await _sGeneral.download(
						item.fileName,
						this.$fun.getUserID()
					);

					if (!response || !response.data) {
						throw new Error("El archivo no se encontró");
					}

					const blob = new Blob([response.data], { type: "application/pdf" });
					this.pdfLocalPath = URL.createObjectURL(blob);
				} catch (error) {
					this.$fun.alert(
						"El documento no está disponible en este momento.",
						"warning"
					);
					this.visorDocumentoVisible = false;
				} finally {
					this.descargandoDocumento = false;
				}
			},
			cerrarVisorPdf() {
				this.visorDocumentoVisible = false;
				if (this.pdfLocalPath) {
					URL.revokeObjectURL(this.pdfLocalPath);
					this.pdfLocalPath = null;
				}
			},

			getHeaderStatusBgColor(row) {
				const statusNum = Number(row.TypeStatusApprovals != null ? row.TypeStatusApprovals : row.typeStatusApprovals);
				const statusName = String(row.TypeStatusApprovalsName || row.typeStatusApprovalsName || "").toUpperCase().trim();

				if (statusName === "SUBSANADO" || statusName.includes("SUBSANAD")) return "purple lighten-5";
				if (statusName === "OBSERVADO" || statusName.includes("OBSERVAD")) return "amber lighten-5";
				if (statusNum === 2 || statusName === "APROBADO" || statusName.includes("LIBRE")) return "teal lighten-5";
				if (statusNum === 3 || statusName === "RESTRINGIDO" || statusName.includes("RESTRING")) return "orange lighten-5";
				if (statusNum === 4 || statusName === "NO CONFORME" || statusName.includes("NO CONFORME") || statusName.includes("RECHAZAD")) return "red lighten-5";
				return "blue-grey lighten-5";
			},
			getHeaderStatusTextColor(row) {
				const statusNum = Number(row.TypeStatusApprovals != null ? row.TypeStatusApprovals : row.typeStatusApprovals);
				const statusName = String(row.TypeStatusApprovalsName || row.typeStatusApprovalsName || "").toUpperCase().trim();

				if (statusName === "SUBSANADO" || statusName.includes("SUBSANAD")) return "purple darken-3";
				if (statusName === "OBSERVADO" || statusName.includes("OBSERVAD")) return "amber darken-4";
				if (statusNum === 2 || statusName === "APROBADO" || statusName.includes("LIBRE")) return "teal darken-3";
				if (statusNum === 3 || statusName === "RESTRINGIDO" || statusName.includes("RESTRING")) return "orange darken-4";
				if (statusNum === 4 || statusName === "NO CONFORME" || statusName.includes("NO CONFORME") || statusName.includes("RECHAZAD")) return "red darken-3";
				return "blue-grey darken-3";
			},
			getHeaderStatusIconColor(row) {
				return this.getHeaderStatusTextColor(row);
			},
			getHeaderStatusColor(row) {
				return this.getHeaderStatusBgColor(row);
			},
			getHeaderStatusIcon(row) {
				const statusNum = Number(row.TypeStatusApprovals != null ? row.TypeStatusApprovals : row.typeStatusApprovals);
				const statusName = String(row.TypeStatusApprovalsName || row.typeStatusApprovalsName || "").toUpperCase().trim();

				if (statusName === "SUBSANADO" || statusName.includes("SUBSANAD")) {
					return "mdi-file-check-outline";
				}
				if (statusName === "OBSERVADO" || statusName.includes("OBSERVAD")) {
					return "mdi-clock-alert-outline";
				}
				if (statusNum === 2 || statusName === "APROBADO" || statusName.includes("LIBRE")) {
					return "mdi-check-circle-outline";
				}
				if (statusNum === 3 || statusName === "RESTRINGIDO" || statusName.includes("RESTRING")) {
					return "mdi-shield-alert-outline";
				}
				if (statusNum === 4 || statusName === "NO CONFORME" || statusName.includes("NO CONFORME") || statusName.includes("RECHAZAD")) {
					return "mdi-close-circle-outline";
				}
				return "mdi-clock-outline";
			},
			getHeaderStatusText(row) {
				if (row.TypeStatusApprovalsName) return row.TypeStatusApprovalsName;
				if (row.typeStatusApprovalsName) return row.typeStatusApprovalsName;
				const statusNum = Number(row.TypeStatusApprovals != null ? row.TypeStatusApprovals : row.typeStatusApprovals);
				switch (statusNum) {
					case 1:
						return "PENDIENTE";
					case 2:
						return "APROBADO";
					case 3:
						return "RESTRINGIDO";
					case 4:
						return "NO CONFORME";
					case 5:
						return "SUBSANADO";
					default:
						return "PENDIENTE";
				}
			},

			onResultsIssueDateChange(item) {
				if (item.ResultsIssueDate && !item.ExpirationDate) {
					try {
						const date = new Date(item.ResultsIssueDate);
						if (!isNaN(date.getTime())) {
							date.setDate(date.getDate() + 30);
							const yyyy = date.getFullYear();
							const mm = String(date.getMonth() + 1).padStart(2, "0");
							const dd = String(date.getDate()).padStart(2, "0");
							this.$set(item, "ExpirationDate", `${yyyy}-${mm}-${dd}`);
						}
					} catch (e) {
						console.error("Error auto-calculating ExpirationDate", e);
					}
				}
			},
			getExpirationDays(row) {
				if (!row || !row.ExpirationDate) return null;
				const expStr = String(row.ExpirationDate).substring(0, 10);
				const exp = new Date(expStr + "T00:00:00");
				if (isNaN(exp.getTime())) return null;

				const today = new Date();
				today.setHours(0, 0, 0, 0);

				const diffMs = exp.getTime() - today.getTime();
				return Math.ceil(diffMs / (1000 * 60 * 60 * 24));
			},
			getExpirationStatusBgColor(row) {
				const days = this.getExpirationDays(row);
				if (days === null) return "grey lighten-4";
				if (days < 0) return "red lighten-5";
				if (days <= 15) return "amber lighten-5";
				return "teal lighten-5";
			},
			getExpirationStatusTextColor(row) {
				const days = this.getExpirationDays(row);
				if (days === null) return "grey darken-3";
				if (days < 0) return "red darken-3";
				if (days <= 15) return "amber darken-4";
				return "teal darken-3";
			},
			getExpirationStatusIconColor(row) {
				return this.getExpirationStatusTextColor(row);
			},
			getExpirationStatusColor(row) {
				return this.getExpirationStatusBgColor(row);
			},
			getExpirationStatusIcon(row) {
				const days = this.getExpirationDays(row);
				if (days === null) return "mdi-clock-outline";
				if (days < 0) return "mdi-alert-circle-outline";
				if (days <= 15) return "mdi-clock-alert-outline";
				return "mdi-check-circle-outline";
			},
			getExpirationStatusText(row) {
				const days = this.getExpirationDays(row);
				if (days === null) return "-";
				if (days < 0) return `Vencido (${Math.abs(days)}d)`;
				if (days === 0) return "Vence Hoy";
				if (days <= 15) return `Por Vencer (${days}d)`;
				return `Vigente (${days}d)`;
			},
			getExpirationStatusTitle(row) {
				const days = this.getExpirationDays(row);
				if (days === null) return "Sin fecha de vencimiento";
				if (days < 0) return `El análisis venció hace ${Math.abs(days)} días. Se requiere nuevo análisis.`;
				if (days === 0) return "El análisis vence el día de hoy.";
				if (days <= 15) return `El análisis vencerá en ${days} días.`;
				return `Análisis vigente por ${days} días más.`;
			},
			newAnalysisForLot(lotData) {
				if (!lotData) return;
				if (this.$refs.crudAnalysis) {
					if (typeof this.$refs.crudAnalysis.btnAdd === "function") {
						this.$refs.crudAnalysis.btnAdd();
					}
					this.$nextTick(() => {
						const target = this.$refs.crudAnalysis.row;
						if (target) {
							this.$set(target, "FltID", lotData.FltID);
							this.$set(target, "FltName", lotData.FltName);
							this.$set(target, "FagName", lotData.FagName);
							this.$set(target, "PrdCardName", lotData.PrdCardName);
							this.$set(target, "CmaID", lotData.CmaID);
							this.$set(target, "TypeAnalysis", lotData.TypeAnalysis);
							this.$set(target, "TypeMatrix", lotData.TypeMatrix);
							const priorityPrefix = lotData.requestPriority ? `[${lotData.requestPriority}] ` : "";
							this.$set(target, "RmnDocumentNumber", `${priorityPrefix}SOLICITUD-${lotData.FltName || "LOTE"}`);
							if (lotData.requestObservation) {
								this.$set(target, "ObservationApproval", lotData.requestObservation);
							}
						}
						this.$fun.alert(
							`Solicitud de Calidad recibida. Se cargaron los datos del lote ${lotData.FltName || lotData.FltID} para Operaciones Agrícolas.`,
							"success"
						);
					});
				}
			},
		},
	};
</script>

<style scoped>
.dropzone-container {
	border: 2px dashed #90caf9;
	background-color: #f8fafc;
	cursor: pointer;
	transition: all 0.25s ease-in-out;
	position: relative;
	overflow: hidden;
}

.dropzone-container:hover {
	border-color: #1976d2;
	background-color: #f0f7ff;
	box-shadow: 0 4px 12px rgba(25, 118, 210, 0.08);
}

.dropzone-container:hover .dropzone-icon-wrapper {
	transform: translateY(-3px);
	background-color: #e3f2fd !important;
}

.dropzone-icon-wrapper {
	transition: transform 0.2s ease, background-color 0.2s ease;
}

.dropzone-active {
	border-color: #1565c0 !important;
	background-color: #e3f2fd !important;
	transform: scale(1.005);
	box-shadow: 0 6px 16px rgba(21, 101, 192, 0.15);
}

.attach-table-wrapper {
	border: 1px solid #e0e0e0;
	border-radius: 8px;
	overflow: hidden;
	background: #fff;
}
</style>
